import { render, staticRenderFns } from "./PlainGoldetails.vue?vue&type=template&id=7e118b5b&scoped=true"
import script from "./PlainGoldetails.vue?vue&type=script&lang=js"
export * from "./PlainGoldetails.vue?vue&type=script&lang=js"
import style0 from "./PlainGoldetails.vue?vue&type=style&index=0&id=7e118b5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e118b5b",
  null
  
)

export default component.exports